import React from 'react';
import {
  PdsBox,
  PdsCard,
  PdsMantineText,
  PdsMantineButton,
  PdsNotification,
  PdsSearchIcon,
  PdsLoginIcon,
  PdsSpinnerIcon,
  PdsShieldSecurityIcon,
} from '@podium-design-system/react-components';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const { login, loading } = useAuth();

  return (
    <PdsBox
      justifyContent="center"
      alignItems="center"
      color="neutral"
      contrast="low"
      style={{ minHeight: '100vh' }}
    >
      <PdsCard
        border
        borderRadius="md"
        padding="lg"
        direction="column"
        gap="md"
        fixedWidth="400px"
      >
        <PdsBox direction="column" alignItems="center" gap="xs">
          <PdsBox direction="row" alignItems="center" gap="xs">
            <PdsSearchIcon color="action" size="md" />
            <PdsMantineText type="headline" fontWeight="strong">
              Argus
            </PdsMantineText>
          </PdsBox>
          <PdsMantineText type="body" color="neutral" textAlign="center">
            Please sign in to continue
          </PdsMantineText>
        </PdsBox>

        <PdsMantineButton
          rank="fill"
          color="action"
          stretch
          disabled={loading}
          onClick={login}
          leadingIcon={loading ? <PdsSpinnerIcon /> : <PdsLoginIcon />}
        >
          {loading ? 'Redirecting...' : 'Sign in with SSO'}
        </PdsMantineButton>

        <PdsNotification
          color="action"
          dismissible={false}
          contentsAs="div"
        >
          <PdsBox direction="column" gap="xs">
            <PdsMantineText type="textline" fontWeight="strong" component="span">
              Single Sign-On Enabled
            </PdsMantineText>
            <PdsBox direction="row" alignItems="center" gap="xs">
              <PdsShieldSecurityIcon color="action" size="sm" />
              <PdsMantineText type="textline" color="action" component="span">
                You will be redirected to the identity provider
              </PdsMantineText>
            </PdsBox>
          </PdsBox>
        </PdsNotification>
      </PdsCard>
    </PdsBox>
  );
};

export default Login;
